import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlogListPage } from './blog-list.component';
import { authGuard } from '@guards/auth.guard';
import { hasRoleGuard } from '@guards/has-role.guard';

const routes: Routes = [
  {
    path: 'blog',
    component: BlogListPage,
    canActivate: [authGuard, hasRoleGuard(null, ['read_blog'])],
    data: {
      title: "Lista de entradas."
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlogListPageRoutingModule { }
